import React from 'react';
import { AccountClock } from 'components/_shared/AccountClock';
import { Container, TitleGroup, PageTitle } from './AccountHeader.styles';

export const AccountHeader = ({ children }) => {
  return (
    <Container>
      <TitleGroup>
        <PageTitle>Edge units</PageTitle>
        {children}
      </TitleGroup>
      <AccountClock />
    </Container>
  );
};
